module.exports = __webpack_public_path__ + "img/agree.1981f1c.svg";